import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import PdfFileData from 'app/Models/Content/PdfFileData';

export default class FoundationPdfFile extends EpiComponent<PdfFileData> {
  componentDidMount() {
    const pdfUrl = this.getContext().getEpiserverUrl(this.props.data.url);
    window.location.replace(pdfUrl);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return null;
  }
}
